import Extend from 'flarum/common/extenders';
import Discussion from 'flarum/common/models/Discussion';
import PaintingsPage from './components/PaintingsPage';
export default [new Extend.Model(Discussion).attribute('paintingImage'), new Extend.Routes().add('paintings', '/paintings', PaintingsPage)];